import styled from 'styled-components';

export const FloatingInformation = styled.div`
  position: fixed;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;

  padding: 0px 5px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 6px 6px 16px rgba(0, 0, 0, 0.08);

  // max-width: 380px;
  // width: fit-content;
`;

export const FloatingInformationText = styled.p`
  color: #15162B;
  font-family: "SF Pro", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 510;
  line-height: normal;
  margin-top: 6px;
`;

export const FloatingInformationImage = styled.img`
  width: 18px;
  height: 18px;
  // margin-top: -10px;
`;

export const PriceInformationIcon = styled.div`
  width: 52.508px;
  height: 51.869px;
  flex-shrink: 0;
  background: rgba(207, 157, 97, 0.16);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PriceInformationIconImage = styled.img`
  width: 30px;
  height: 30px;
`;

export const PriceInformationIconContainer = styled.div`
  width: 72px;
  height: 71.124px;
  flex-shrink: 0;
  background: rgba(207, 157, 97, 0.05);
  border-radius: 50%;
  margin-bottom: 20.88px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconContainerNoBackground = styled.div`
  // width: 72px;
  // height: 71.124px;
  flex-shrink: 0;
   
  margin-bottom: 20.88px;
  display: flex;
  justify-content: center;
  align-items: center;
`;


export const PriceInformationBtn = styled.div`
  // width: 100%;
  width: 50%;
  margin: 0 auto;
`;

export const PriceInformationMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const PriceInformationTitle = styled.h3`
  color: #15162B;
  text-align: center;
  font-family: "SF Pro", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 32px;
  width: 277px;
`;

export const PriceInformationMessage = styled.p`
  color: #434455;
  text-align: center;
  font-family: "SF Pro", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 20px;
  width: 243px;
`;


export const CloseIconContainer = styled.div`
  font-size: 20px;
  position: absolute;
  top: -5px;
  right: 10px;
  cursor: pointer;
  color: #15162B;
`;